enum MessageSource {
    Server = 0,
    Mobile = 1,
    Customer = 2
}

export default MessageSource;